/**
 * The fiscal providers a legal area can be switched to.
 *
 * The member names are INTERNAL vocabulary and mirror the backend enum
 * (`API.Core/Enums/Connectors/Legal/LegalProvider.cs`) — the ordinal is what rides the wire as
 * `?provider=`, so the order is fixed and the names must not be renamed for cosmetic reasons.
 * What a person reads is {@link LegalProviderHelper.GetName}, and only that.
 */
export enum LegalProvider {
  None,
  Fiskaly
}

/**
 * Display names for {@link LegalProvider}.
 *
 * **These strings name the thing, never its supplier (#241).** Feature #241's hard constraint is that an
 * operator and their tax adviser do the legally required fiscal work in this application and are never told
 * whose service performs it — so the card that was once labelled with the supplier's own brand is labelled
 * „Cloud-TSE": what it is and where it lives. That also leaves room for a „Hardware-TSE" card later without
 * renaming anything a reader has already learnt.
 *
 * Every rendering of a provider on the legal screens goes through {@link GetName} — the cards, the switch
 * buttons' `aria-label`s, and the `providerName` the confirmation dialog prints — so this table is the one
 * place the wording lives. Pinned by `settings.component.spec.ts`' *supplier identity* region, which asserts
 * CONTAINS-style over the whole rendered screen rather than against today's copy.
 *
 * The end-user documentation quotes these labels verbatim (`StaticPages/docs/GLOSSARY.md`); changing one is a
 * documentation change too.
 */
export class LegalProviderHelper {
  private static names: string[] = ["Keiner", "Cloud-TSE"];

  public static GetName(value: LegalProvider): string {
    return this.names[value];
  }

  public static GetProviders: LegalProvider[] = [LegalProvider.None, LegalProvider.Fiskaly];
}
